<template>
  <IconButton bgColor="#16AFC7" :svg="$assets.svg['more_info_icon']" @click="click"> More Info </IconButton>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import $assets from '@/assets';
import IconButton from '@/components/event/IconButton.vue';

const emit = defineEmits(['click']);
const props = defineProps({
  evEventOrCourse: {
    type: Object,
    default: () => ({}),
  },
});

const $route = useRoute();
const $router = useRouter();

const isProfessionalEvent = computed(() => {
  return props.evEventOrCourse.type_code === 'PROFESSIONAL';
});

function click() {
  if (isProfessionalEvent.value) {
    // If user click more-info button on card in typeEvents page
    // The levelup page should be typeEvents instead of eventHome
    // That means the back button on left nav bar direct them back to typeEvents page
    // So we need to pass typecode for building levelup parameter (line 61 in /src/router/event.js)
    // I add a config for this at line 31 in /src/router/event.js
    if ($route.name === 'typeEvents') {
      $router.push({
        name: 'typeEventCourse',
        params: {
          typecode: props.evEventOrCourse.type_code,
          eventId: props.evEventOrCourse.id,
        },
      });
    } else {
      $router.push({
        name: 'course',
        params: { eventId: props.evEventOrCourse.id },
      });
    }

    return;
  }

  emit('click');
}
</script>

<style scoped></style>
